const _excluded = ["label"],
      _excluded2 = ["label"],
      _excluded3 = ["hint", "error"],
      _excluded4 = ["hint", "label"],
      _excluded5 = ["className", "children", "onSubmit", "acceptCharset"],
      _excluded6 = ["label", "hint", "checked"],
      _excluded7 = ["label", "hint", "items"];
var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/forms/index.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Text, Select } from '../../components/ui';
export const InputContainer = props => {
  const containerClass = classNames('input', {
    'with_label': props.label,
    'required': props.required,
    'boolean': props.type === 'checkbox',
    'field_with_errors': props.error
  }, props.extraClass);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, props.children, props.hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 22
    }
  }, props.hint));
};
export const LabelInputContainer = _ref => {
  let {
    label,
    hint,
    children
  } = _ref;
  const [id] = useState(uuidv4());
  const childrenWithProps = React.Children.map(children, child =>
  /*#__PURE__*/
  // @ts-ignore: not sure how to get the right type here
  React.cloneElement(child, {
    id: id,
    key: id
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "label_input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "label_input__wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, childrenWithProps), hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 16
    }
  }, hint));
};
export const LabelInput = _ref2 => {
  let {
    label
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 5
    }
  })));
};
export const LabelTextarea = _ref3 => {
  let {
    label
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 5
    }
  })));
};
export const SimpleInput = props => {
  const {
    hint,
    error
  } = props,
        rest = _objectWithoutProperties(props, _excluded3);

  const Input = props.label ? LabelInput : 'input';
  return /*#__PURE__*/React.createElement(InputContainer, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  })));
};
export const SimpleTextarea = props => {
  const {
    hint,
    label
  } = props,
        rest = _objectWithoutProperties(props, _excluded4);

  const Input = label ? LabelTextarea : 'textarea';
  return /*#__PURE__*/React.createElement(InputContainer, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 7
    }
  })));
};
export const SimpleForm = props => {
  const {
    className,
    children,
    onSubmit = () => {},
    acceptCharset = 'UTF-8'
  } = props,
        rest = _objectWithoutProperties(props, _excluded5);

  const handleSubmit = e => {
    onSubmit(e);
    e.preventDefault();
  };

  return /*#__PURE__*/React.createElement("form", _extends({
    className: classNames('simple_form', className),
    method: "post",
    onSubmit: handleSubmit,
    acceptCharset: acceptCharset
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 5
    }
  }), children);
};
export const FieldsGroup = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: "fields-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 3
    }
  }, children);
};
export const Checkbox = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "checkbox"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 175,
    columnNumber: 3
  }
}));
export const RadioGroup = props => {
  const {
    label,
    children,
    onChange
  } = props;
  const childrenWithProps = React.Children.map(children, child =>
  /*#__PURE__*/
  // @ts-ignore
  React.cloneElement(child, {
    onChange
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "input with_floating_label radio_buttons",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "label_input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("label", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 9
    }
  }, label), /*#__PURE__*/React.createElement("ul", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 9
    }
  }, childrenWithProps)));
};
export const RadioItem = props => {
  const {
    current: id
  } = useRef(uuidv4());

  const {
    label,
    hint,
    checked = false
  } = props,
        rest = _objectWithoutProperties(props, _excluded6);

  return /*#__PURE__*/React.createElement("li", {
    className: "radio",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "radio",
    checked: checked
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 9
    }
  }, label), hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 18
    }
  }, hint)));
};
export const SelectDropdown = props => {
  const {
    label,
    hint,
    items
  } = props,
        rest = _objectWithoutProperties(props, _excluded7);

  const optionElems = Object.keys(items).map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    value: item,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236,
      columnNumber: 5
    }
  }, items[item])); // @ts-ignore

  const selectElem = /*#__PURE__*/React.createElement(Select, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 22
    }
  }), optionElems);
  return label ? /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    hint: hint,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 5
    }
  }, selectElem) : selectElem;
};
export const TextInput = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "text"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 263,
    columnNumber: 3
  }
}));
export const FileChooser = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "file"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 267,
    columnNumber: 3
  }
}));
FileChooser.defaultProps = {
  accept: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
};
export const FileChooserLogo = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "file"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 283,
    columnNumber: 3
  }
}));
FileChooserLogo.defaultProps = {
  accept: ['image/svg', 'image/png']
};